<div class="search-suggestions">
  <div class="inner d-flex flex-column align-items-start p-3 shadow rounded" style="background-color: var(--white)" (clickOutside)="searchSuggestions = []" *ngIf="searchSuggestions?.length">
    <ng-container *ngFor="let entry of searchSuggestions; index as i">
      <!-- {{historyStartsFromIndex}} {{i}} -->
      <div class="d-flex align-items-center">
        <i class="fa fa-history mr-2" *ngIf="historyStartsFromIndex != -1 && i >= historyStartsFromIndex"></i>
        @if (entry.type == "company") {
          <button class="t-btn w-100 py-1" style="text-align: left; line-height: 1.6" (click)="openSuggestionText(entry)">{{ entry.name }} ( <b>Company</b> )</button>
        } @else {
          <button class="t-btn w-100 py-1" style="text-align: left; line-height: 1.6" (click)="openSuggestionText(entry)">
            {{ entry.name }}
            <ng-container *ngIf="historyStartsFromIndex == -1 || i < historyStartsFromIndex">
              ( <b>{{ entry.type == "type" ? entry.parentCategoryName : entry.type == "cat" ? "Category" : "Subcategory" }}</b> )</ng-container
            >
          </button>

          <ng-container *ngIf="entry?.types">
            <button class="t-btn w-100 py-1" style="text-align: left; line-height: 1.6" *ngFor="let subTypes of entry?.types" (click)="openSuggestionText(subTypes)">{{ subTypes.name }} (<b>Type</b>)</button>
          </ng-container>
          <ng-container *ngIf="entry?.subcats">
            <ng-container *ngFor="let subEntry of entry?.subcats">
              <button class="t-btn w-100 py-1" style="text-align: left; line-height: 1.6" (click)="openSuggestionText(subEntry)">{{ subEntry.name }} (<b>Subcategory</b>)</button>
              <ng-container *ngIf="subEntry?.types">
                <button class="t-btn w-100 py-1" style="text-align: left; line-height: 1.6" *ngFor="let subTypes of subEntry?.types" (click)="openSuggestionText(subTypes)">{{ subTypes.name }} (<b>Type</b>)</button>
              </ng-container>
            </ng-container>
          </ng-container>
        }
        <button (click)="removeSearch(entry)"
         class="t-btn ml-2" *ngIf="historyStartsFromIndex != -1 && i >= historyStartsFromIndex">
              <i class="fa fa-x" ></i>
        </button>
     
      </div>
    </ng-container>
  </div>
</div>
